import { makeStyles, Menu, MenuItem } from '@material-ui/core';
import React from 'react';
import CustomPopupText from './CustomPopupText';

const useStyles = makeStyles({
  menuItem: {
    justifyContent: 'left',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  itemText: {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16.56px',
    marginLeft: '2px',
  },
  icon: {
    padding: '2px',
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
  },
});

export function CustomMenu({ id, handleMenuItemClick, menuItems, anchorEl, handleClose }) {
  const classes = useStyles();

  return (
    <Menu
      id="simple-menu"
      sx={{
        width: '144px',
      }}
      keepMounted
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handleClose}
    >
      {menuItems?.map((item) => (
        <MenuItem
          className={classes.menuItem}
          id={id}
          data-id={id}
          key={item.name}
          onClick={(e) => {
            handleMenuItemClick(e, item.name);
            handleClose();
          }}
        >
          {item.icon && (
            <span id={id} className={classes.icon}>
              {item.icon}
            </span>
          )}
          <CustomPopupText
            id={id}
            text={item.name}
            color="#667085"
            fontSize="12px"
            fontWeight="600"
            lineHeight="16.56px"
            className={classes.itemText}
          />
        </MenuItem>
      ))}
    </Menu>
  );
}
